var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 990 720"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EK1"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK1",
    className: "cls-2",
    x: 274,
    y: 113,
    width: 32,
    height: 64
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "EK2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    "data-id": "EK2",
    points: "306 137.19 338 137 338 202 306 202 306 137.19"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "EK3"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK3",
    className: "cls-2",
    x: 354,
    y: 137,
    width: 32,
    height: 65
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "EK4"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "EK4",
    className: "cls-2",
    points: "419 139 419 202 386 202 386 137 419 139"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "EK5"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK5",
    className: "cls-2",
    x: 537,
    y: 137,
    width: 47,
    height: 65
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "EK6"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK6",
    className: "cls-2",
    x: 596,
    y: 137,
    width: 32,
    height: 65
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "EK7"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK7",
    className: "cls-2",
    x: 628,
    y: 137,
    width: 33,
    height: 65
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "EK8"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK8",
    className: "cls-2",
    x: 673,
    y: 137,
    width: 32,
    height: 65
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "EK9"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK9",
    className: "cls-2",
    x: 705,
    y: 137,
    width: 33,
    height: 65
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "EK10"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK10",
    className: "cls-2",
    x: 811,
    y: 137,
    width: 32,
    height: 65
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "EK11"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK11",
    className: "cls-2",
    x: 843,
    y: 137,
    width: 33,
    height: 65
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "EK122"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK12",
    className: "cls-2",
    x: 755,
    y: 265,
    width: 33,
    height: 64
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "EK13"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK13",
    className: "cls-2",
    x: 711,
    y: 265,
    width: 32,
    height: 64
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "EK14"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK14",
    className: "cls-2",
    x: 678,
    y: 265,
    width: 33,
    height: 64
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "EK15"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK15",
    className: "cls-2",
    x: 629,
    y: 265,
    width: 32,
    height: 64
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "EK16"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK16",
    className: "cls-2",
    x: 596,
    y: 265,
    width: 33,
    height: 64
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "EK17"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK17",
    className: "cls-2",
    x: 547,
    y: 265,
    width: 32,
    height: 64
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "EK18"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK18",
    className: "cls-2",
    x: 514,
    y: 265,
    width: 33,
    height: 64
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "EK19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    "data-id": "EK19",
    points: "497 265 497 329 471 329 471 330 466 330 466 265 497 265"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "EK20"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK20",
    className: "cls-2",
    x: 433,
    y: 265,
    width: 33,
    height: 65
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "EK21"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK21",
    className: "cls-2",
    x: 384,
    y: 265,
    width: 32,
    height: 65
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "EK22"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK22",
    className: "cls-2",
    x: 351,
    y: 265,
    width: 33,
    height: 65
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "EK23"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK23",
    className: "cls-2",
    x: 253,
    y: 406,
    width: 64,
    height: 32
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "EK24"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK24",
    className: "cls-2",
    x: 253,
    y: 438,
    width: 64,
    height: 32
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "EK25"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK25",
    className: "cls-2",
    x: 253,
    y: 470,
    width: 64,
    height: 33
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "EK26"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK26",
    className: "cls-2",
    x: 253,
    y: 509,
    width: 64,
    height: 32
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "EK27"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK27",
    className: "cls-2",
    x: 253,
    y: 541,
    width: 64,
    height: 32
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "EK28"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK28",
    className: "cls-2",
    x: 253,
    y: 573,
    width: 64,
    height: 33
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "EK29"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK29",
    className: "cls-2",
    x: 125,
    y: 574,
    width: 65,
    height: 32
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "EK30"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK30",
    className: "cls-2",
    x: 125,
    y: 542,
    width: 65,
    height: 32
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "EK31"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK31",
    className: "cls-2",
    x: 125,
    y: 509,
    width: 65,
    height: 33
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "EK32"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK32",
    className: "cls-2",
    x: 125,
    y: 471,
    width: 65,
    height: 32
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "EK33"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK33",
    className: "cls-2",
    x: 125,
    y: 439,
    width: 65,
    height: 32
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "EK34"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK34",
    className: "cls-2",
    x: 125,
    y: 406,
    width: 65,
    height: 33
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "EK35"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK35",
    className: "cls-2",
    x: 125,
    y: 357,
    width: 65,
    height: 32
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "EK36"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK36",
    className: "cls-2",
    x: 125,
    y: 324,
    width: 65,
    height: 33
  }))));
}
export default "data:image/svg+xml;base64,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";
export { SvgP1 as ReactComponent };